import authApi from './authApi';
import { redirectUser } from './user';
import { getLanguage } from './auth';
import { transcodeLanguage } from '../utils/language';
import { saveRecentAccount } from '../utils/recentAccounts';
import { getLoginCallbackUrl } from '../utils/mcpOAuthParams';

export function getMagicLinkParams(search = window.location.search) {
  const params = new URLSearchParams(search);

  return {
    token: params.get('token'),
    email: params.get('email'),
    source: params.get('source'),
  };
}

export async function verifyMagicLink({ token, email, source, signal }) {
  const response = await authApi.post(
    '/magic_link_verify',
    {
      token,
      email,
      callback_url: getLoginCallbackUrl(),
      language: transcodeLanguage(getLanguage()),
    },
    { signal },
  );

  saveRecentAccount({
    name: email.split('@')[0],
    email,
    provider: 'magic_link',
  });

  if (source === 'mobile' && response.data?.token) {
    window.location.href = `mlabs://connect?token=${encodeURIComponent(response.data.token)}`;
    return;
  }

  await redirectUser(response);
}
